import { buildUrl } from "../../utils/url"

export const makeHolidayApiEndpoints = (holidayId = ":holidayId") => {
  return {
    holidays: (params?: URLSearchParams) => buildUrl("/holidays", params),
    holidayItem: (id = holidayId) => `/holidays/${id}`,
  }
}
